import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'

/**
 * For a given dataset field, returns a localized and capitalized message for
 * "Not in any range/category", depending on whether the field has ranges or
 * categories
 */
function notInAnyRangeMessage (field) {
	let msg = i18n.get(isNumericDataType(field.dataType)
		? 'datasets.filters.pretty.notInAnyRange'
		: 'datasets.filters.pretty.notInAnyCategory')

	return _.capitalize(msg)
}

export default notInAnyRangeMessage

notInAnyRangeMessage.__filename__ = 'datasets/not-in-any-range-message.js'
